/** 公司类型 */
export const COMPANY_TYPE = {
    PARENT: 'parent',
    SUBSIDIARY: 'subsidiary',
    BRANCH: 'branch',
} as const;

/** 默认最大树层级 */
export const DEFAULT_MAX_TREE_LEVEL = 5;

/** 公司搜索默认页大小 */
export const COMPANY_SEARCH_PAGE_SIZE = 20;

/** API 路径 */
export const COMPANY_API_PATHS = {
    TREE: '/company-tree',
    NAME: '/company-tree/company-name',
} as const;

export const AUTOCOMPLETE_SITE_LANG_MAP = {
    cn: ['cname_cn', 'cname_en', 'cname_other', 'nname_cn', 'nname_en', 'nname_jp', 'nname_kr', 'nname_other'],
    tw: ['cname_cn', 'cname_en', 'cname_other', 'nname_cn', 'nname_en', 'nname_jp', 'nname_kr', 'nname_other'],
    en: ['cname_en', 'cname_other', 'cname_cn', 'nname_en', 'nname_jp', 'nname_kr', 'nname_other', 'nname_cn'],
    jp: ['cname_en', 'cname_other', 'cname_cn', 'nname_en', 'nname_jp', 'nname_kr', 'nname_other', 'nname_cn'],
};


export const TREE_COMPANY_SITE_LANG_MAP = {
    cn: ['cn_name', 'en_name', 'jp_name', 'kr_name', 'other_name'],
    tw: ['cn_name', 'en_name', 'jp_name', 'kr_name', 'other_name'],
    en: ['en_name', 'jp_name', 'kr_name', 'other_name', 'cn_name'],
    jp: ['en_name', 'jp_name', 'kr_name', 'other_name', 'cn_name'],
};
